import React, { useState } from 'react';
import { Box, Typography, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DatePicker from 'components/@common/Inputs/DatePicker';
import { HwtButton } from 'components/@common/Buttons/HwtButton';
import { translate } from 'translations/translator';
import { useDispatch, batch } from 'react-redux';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import { saveTeachingOrderStartDate } from 'state/modules/user/thunks';
import { fetchLessonPlan } from 'state/modules/entity/thunks/lesson-planner';
import ModalsTranslationVariant from 'translations/variants/modals';
import CommonTranslationVariant from 'translations/variants/common';
import { ModalPadding } from 'styles/style-constants';

const getTranslation = key => translate('modals', key);
const translateCommon = (key: CommonTranslationVariant) => translate('common', key);

export const SelectStartDateModalBackdrop: React.FC<any> = () => (
  <Typography
    variant="h4"
    style={{
      display: 'flex',
      alignSelf: 'flex-start',
      marginTop: 280,
      color: '#fff',
      fontWeight: 400
    }}
  >
    {getTranslation(ModalsTranslationVariant.waitThisIsImportant)}
  </Typography>
);

const SelectStartDateModal: React.FC = () => {
  const [, { closeModal }] = useModal();
  const [selectedDate, setSelectedDate] = useState<any>(new Date());
  const classes = useStyles();
  const dispatch = useDispatch() as any;

  const handleSetStartDate = async () => {
    closeModal();

    batch(async () => {
      await dispatch(saveTeachingOrderStartDate(selectedDate));
      await dispatch(fetchLessonPlan());
    });
  };

  const handleCalendarChange = (_, value) => setSelectedDate(value);

  return (
    <Container className={classes.container}>
      <Box>
        <Typography variant="h4" style={{ textAlign: 'center', marginBottom: 15 }}>
          {getTranslation(ModalsTranslationVariant.tellUsWhenToBegin)}
        </Typography>
        <Typography variant="h6" style={{ fontWeight: 300 }}>
          {getTranslation(ModalsTranslationVariant.tourStartDateDetails)}
        </Typography>
        <DatePicker
          label={getTranslation(ModalsTranslationVariant.schoolStartDate)}
          shouldDisableWeekends
          name={translateCommon(CommonTranslationVariant.chooseDate)}
          value={selectedDate}
          onChange={handleCalendarChange}
        />
      </Box>
      <Box className={classes.actionGroup}>
        <HwtButton variant="contained" disabled={!selectedDate} onClick={handleSetStartDate}>
          {getTranslation(ModalsTranslationVariant.setStartDate)}
        </HwtButton>
      </Box>
    </Container>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    height: '350px',
    width: '594px',
    backgroundColor: '#fff',
    ...ModalPadding
  },
  actionGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '20px'
  },
  picker: {
    display: 'flex',
    flex: 1
  }
}));

export default SelectStartDateModal;
